/* Wilted Apathy theme JS — cart drawer, variant selection, mobile menu */
(function () {
  'use strict';

  var drawer = document.getElementById('cartDrawer');
  var cartItemsEl = document.getElementById('cartItems');
  var cartCountEl = document.getElementById('cartCount');
  var cartTotalEl = document.getElementById('cartTotal');
  var toast = document.getElementById('toast');
  var menuSheet = document.getElementById('menuSheet');

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function showToast(msg) {
    if (!toast) return;
    var original = toast.dataset.original || toast.textContent;
    toast.dataset.original = original;
    toast.textContent = msg;
    toast.classList.add('show');
    setTimeout(function () {
      toast.classList.remove('show');
      setTimeout(function () { toast.textContent = original; }, 300);
    }, 1600);
  }

  function openCart() {
    if (!drawer) return;
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    renderCart();
  }

  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
  }

  function cartItemHTML(item) {
    var img = item.image
      ? '<img src="' + item.image.replace(/(\.[a-z]+)$/i, '_160x$1') + '" alt="">'
      : '';
    var opts = (item.options_with_values || [])
      .map(function (o) { return o.value; })
      .filter(Boolean)
      .join(' · ');
    return (
      '<div class="cart-item">' +
        img +
        '<div><strong>' + item.product_title + '</strong>' +
        (opts ? '<small>' + opts + '</small>' : '') +
        '<small>Qty ' + item.quantity + '</small>' +
        '<small>' + money(item.final_line_price) + '</small></div>' +
        '<button class="remove" data-remove-key="' + item.key + '" aria-label="Remove ' + item.product_title + '">✕</button>' +
      '</div>'
    );
  }

  function renderCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cartCountEl) cartCountEl.textContent = cart.item_count;
        if (cartTotalEl) cartTotalEl.textContent = money(cart.total_price);
        if (cartItemsEl) {
          cartItemsEl.innerHTML = cart.items.length
            ? cart.items.map(cartItemHTML).join('')
            : '<p class="empty">Your bag is empty.</p>';
        }
      })
      .catch(function () {});
  }

  function addToCart(variantId, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty || 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        showToast('Added to bag');
        openCart();
      })
      .catch(function () {
        showToast('Could not add to bag');
      });
  }

  /* ---- Variant selection on product pages ---- */
  function initVariantPickers() {
    document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
      var variants = JSON.parse(picker.dataset.variants || '[]');
      var form = picker.closest('form');
      var idInput = form ? form.querySelector('[name="id"]') : null;
      var priceEl = form ? form.parentElement.querySelector('[data-variant-price]') : null;
      var addBtn = form ? form.querySelector('[data-add-to-cart]') : null;

      function currentVariant() {
        var selected = {};
        picker.querySelectorAll('[data-option-name]').forEach(function (group) {
          var name = group.dataset.optionName;
          var btn = group.querySelector('.choice.selected');
          if (btn) selected[name] = btn.dataset.optionValue;
        });
        return (
          variants.find(function (v) {
            return v.options.every(function (opt, i) {
              var name = picker.querySelectorAll('[data-option-name]')[i];
              return !name || selected[name.dataset.optionName] === opt;
            });
          }) || null
        );
      }

      function refresh() {
        var v = currentVariant();
        if (idInput && v) idInput.value = v.id;
        if (priceEl && v) priceEl.textContent = money(v.price);
        if (addBtn) {
          var available = v && v.available;
          addBtn.disabled = !available;
          addBtn.querySelector('[data-add-label]').textContent = available
            ? 'Add to bag — ' + money(v.price)
            : 'Sold out';
        }
      }

      picker.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-option-value]');
        if (!btn) return;
        var group = btn.closest('[data-option-name]');
        group.querySelectorAll('.choice').forEach(function (b) {
          b.classList.toggle('selected', b === btn);
        });
        refresh();
      });

      refresh();
    });

    /* Product form submit -> AJAX add */
    document.querySelectorAll('form[action="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var id = form.querySelector('[name="id"]').value;
        addToCart(id, 1);
      });
    });
  }

  /* ---- Quick add from cards (uses first available variant) ---- */
  document.addEventListener('click', function (e) {
    var routeEl = e.target.closest('[data-route-link]');
    if (routeEl) return; /* normal links */

    var remove = e.target.closest('[data-remove-key]');
    if (remove) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: remove.dataset.removeKey, quantity: 0 })
      }).then(renderCart);
      return;
    }

    if (e.target.closest('[data-close-cart]')) { closeCart(); return; }
  });

  var cartBtn = document.getElementById('cartBtn');
  if (cartBtn) cartBtn.addEventListener('click', openCart);

  var menuBtn = document.getElementById('menuBtn');
  if (menuBtn && menuSheet) {
    menuBtn.addEventListener('click', function () {
      menuSheet.classList.toggle('open');
    });
  }

  /* Collection filter buttons (Shop All page) */
  document.addEventListener('click', function (e) {
    var f = e.target.closest('[data-type-filter]');
    if (!f) return;
    var type = f.dataset.typeFilter;
    document.querySelectorAll('[data-type-filter]').forEach(function (b) {
      b.classList.toggle('active', b === f);
    });
    document.querySelectorAll('#collectionGrid [data-product-type]').forEach(function (card) {
      var t = (card.dataset.productType || '').toLowerCase();
      var show =
        type === 'all' ||
        (type === 'tees' && (t.indexOf('tee') > -1 || t.indexOf('t-shirt') > -1 || t.indexOf('tshirt') > -1)) ||
        (type === 'hoodies' && t.indexOf('hoodie') > -1) ||
        (type === 'sweatpants' && (t.indexOf('sweatpant') > -1 || t.indexOf('pant') > -1));
      card.style.display = show ? '' : 'none';
    });
    var count = document.getElementById('collectionCount');
    if (count) {
      var visible = Array.prototype.filter.call(
        document.querySelectorAll('#collectionGrid [data-product-type]'),
        function (c) { return c.style.display !== 'none'; }
      ).length;
      count.textContent = visible + ' pieces';
    }
  });

  initVariantPickers();
  renderCart();
})();
